import axios from "axios";
import {apiUri} from "../../config";
import {push} from "connected-react-router";

export const FETCH_ACEALERTS_ATTEMPT = 'FETCH_ACEALERTS_ATTEMPT';
export const FETCH_ACEALERTS_SUCCESS = 'FETCH_ACEALERTS_SUCCESS';
export const FETCH_ACEALERTS_FAILURE = 'FETCH_ACEALERTS_FAILURE';

export const CREATE_ACEALERTS_ATTEMPT = 'CREATE_ACEALERTS_ATTEMPT';
export const CREATE_ACEALERTS_SUCCESS = 'CREATE_ACEALERTS_SUCCESS';
export const CREATE_ACEALERTS_FAILURE = 'CREATE_ACEALERTS_FAILURE';

export const FETCH_ACEALERT_ATTEMPT = 'FETCH_ACEALERT_ATTEMPT';
export const FETCH_ACEALERT_SUCCESS = 'FETCH_ACEALERT_SUCCESS';
export const FETCH_ACEALERT_FAILURE = 'FETCH_ACEALERT_FAILURE';

export const SELECT_ACEALERT = 'SELECT_ACEALERT';

export const ACEALERT_UPDATE = 'ACEALERT_UPDATE';
export const ACEALERT = 'ACEALERT';

global.loader = false;

export const fetch_alerts = ({page=0, search='', sortKey='', sortOrder=''}) => {
	return (dispatch) => {
		dispatch({type: FETCH_ACEALERTS_ATTEMPT, page: page});
		axios.get(apiUri + "/alert?page=" + page + "&search=" + search  + "&sortField=" + sortKey + "&order=" + sortOrder)
			.then(json => {
				const response = json.data;
				dispatch({
					type: FETCH_ACEALERTS_SUCCESS,
					data: response.content,
					page: page,
					total_pages: response.totalPages
				})
			})
			.catch(err => {
				dispatch({type: FETCH_ACEALERTS_FAILURE, error: err})
			})
	}
};

export const select_dando = (alert_id) => {
	return (dispatch) => {
		dispatch({type: SELECT_ACEALERT, id: alert_id});
		dispatch(push("/dando/" + alert_id));
	}
};
export const send_email = (alertData) => {
	return (dispatch) => {
		dispatch({type: ACEALERT, alertType:alertData});
		// dispatch(push("/dando/" + alert_id));
	}
};






// WEBPACK FOOTER //
// ./src/ace/redux/actions.js